<template>
  <div>

    <div class="flex flex-wrap -mx-1">
      <div class="w-full md:w-1/3 px-1 pb-2" v-for="(group, name) in grouped" :key="'group-' + name">
        <div class="h-full bg-theme-400 p-2 rounded">
          <p class="text-lg font-bold text-center mt-2 mb-4">{{ name | upperCase }}</p>
          <div class="flex flex-wrap justify-center">
            <router-link
              tag="button"
              :to="link.path"
              class="btn text-sm flex items-center focus:outline-none border mr-2 mb-2"
              :class="$route.name === link.route ? 'btn-purple border-purple-400' : 'border-gray-700 light:border-gray-300'"
              v-for="(link, i) in group"
              :key="'links-' + i"
            >
              <span class="font-bold" :class="link.class ? link.class : 'text-link'">•</span>
              <span class="ml-1">{{ link.title }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          title: 'Sales Cash',
          path: '/report/accounting/sales-cash-invoices',
          route: 'report.accounting.sales-cash-invoices',
          group: 'invoices',
          class: 'text-green-500',
        },
        {
          title: 'Sales Settled Credit',
          path: '/report/accounting/sales-settled-credit-invoices',
          route: 'report.accounting.sales-settled-credit-invoices',
          group: 'invoices',
          class: 'text-green-500',
        },
        {
          title: 'Sales Unsettled Credit',
          path: '/report/accounting/sales-unsettled-credit-invoices',
          route: 'report.accounting.sales-unsettled-credit-invoices',
          group: 'invoices',
          class: 'text-green-500',
        },
        {
          title: 'Purchases Cash',
          path: '/report/accounting/purchases-cash-invoices',
          route: 'report.accounting.purchases-cash-invoices',
          group: 'invoices',
          class: 'text-red-500',
        },
        {
          title: 'Purchases Settled Credit',
          path: '/report/accounting/purchases-settled-credit-invoices',
          route: 'report.accounting.purchases-settled-credit-invoices',
          group: 'invoices',
          class: 'text-red-500',
        },
        {
          title: 'Purchases Unsettled Credit',
          path: '/report/accounting/purchases-unsettled-credit-invoices',
          route: 'report.accounting.purchases-unsettled-credit-invoices',
          group: 'invoices',
          class: 'text-red-500',
        },
        {
          title: 'Sales Settled',
          path: '/report/accounting/sales-settled-credit-notes',
          route: 'report.accounting.sales-settled-credit-notes',
          group: 'credit-notes',
          class: 'text-green-500',
        },
        {
          title: 'Sales Unsettled',
          path: '/report/accounting/sales-unsettled-credit-notes',
          route: 'report.accounting.sales-unsettled-credit-notes',
          group: 'credit-notes',
          class: 'text-green-500',
        },
        {
          title: 'Purchases Settled',
          path: '/report/accounting/purchases-settled-credit-notes',
          route: 'report.accounting.purchases-settled-credit-notes',
          group: 'credit-notes',
          class: 'text-red-500',
        },
        {
          title: 'Purchases Unsettled',
          path: '/report/accounting/purchases-unsettled-credit-notes',
          route: 'report.accounting.purchases-unsettled-credit-notes',
          group: 'credit-notes',
          class: 'text-red-500',
        },
        {
          title: 'Sales',
          path: '/report/accounting/sales-receipts',
          route: 'report.accounting.sales-receipts',
          group: 'receipts',
          class: 'text-green-500',
        },
        {
          title: 'Purchases',
          path: '/report/accounting/purchases-receipts',
          route: 'report.accounting.purchases-receipts',
          group: 'receipts',
          class: 'text-red-500',
        },
      ]
    }
  },
  computed: {
    grouped() {
      let group = {}
      for (let i in this.links) {
        let link = this.links[i]
        if (link.group) {
          if (!group[link.group]) {
            group[link.group] = []
          }
          group[link.group].push(link)
        }
      }
      return group
    }
  }
}
</script>

